import { EigentumanteilMasterDetailEntryMeta } from '../../../core/gb-api';
import { TranslateService } from '@ngx-translate/core';
import { EigentumanteilVersionVm } from './eigentumanteil-version-vm';

export class EigentumanteilMasterDetailVM {
  versionenVm: EigentumanteilVersionVm[];

  constructor(
    public object: EigentumanteilMasterDetailEntryMeta,
    private translateService: TranslateService
  ) {
    if (object) {
      this.versionenVm = new Array<EigentumanteilVersionVm>();
      if (object.versions) {
        for (let i = 0; i < object.versions.length; i++) {
          this.versionenVm.push(new EigentumanteilVersionVm(object.versions[i], this.translateService));
        }
      }
    }
  }
}
